import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { BaseEmailInput } from 'src/components/BaseEmailInput/BaseEmailInput';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface DinerEmailFilterControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function DinerEmailFilterControl({
  name,
  id,
  rules,
}: DinerEmailFilterControlProps): JSX.Element {
  return (
    <BaseEmailInput
      name={name}
      id={id}
      label={addAsterisk('Filter by Employee Email', rules)}
      rules={rules}
    />
  );
}
